import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Menu from "./pages/Menu";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import Admin from "./pages/Admin";
import Poster from "./pages/Poster";
import FacebookAvatar from "./pages/FacebookAvatar";
import FacebookCover from "./pages/FacebookCover";
import SocialItems from "./pages/SocialItems";
import SaturdayPromo from "./pages/SaturdayPromo";
import NewItemAds from "./pages/NewItemAds";
import MenuAd from "./pages/MenuAd";
import MenuAdV2 from "./pages/MenuAdV2";
import MenuAdV2Photo from "./pages/MenuAdV2Photo";
import FoodCollage from "./pages/FoodCollage";
import HookAd from "./pages/HookAd";
import Flyer from "./pages/Flyer";
import TableFlyer from "./pages/TableFlyer";
import TableFlyerFront from "./pages/TableFlyerFront";
import TableFlyerBack from "./pages/TableFlyerBack";
import TableFlyerAll from "./pages/TableFlyerAll";
import ReviewQR from "./pages/ReviewQR";
import SushiAd from "./pages/SushiAd";
import KitchenChart from "./pages/KitchenChart";
import OktoberfestAd from "./pages/OktoberfestAd";
import BBQBoatAds from "./pages/BBQBoatAds";
import BoatHeroAd from "./pages/BoatHeroAd";
import CowboySushiAd from "./pages/CowboySushiAd";
import { CartProvider } from "./context/CartContext";
import CartDrawer from "./components/CartDrawer";
import CartButton from "./components/CartButton";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Routes>
            <Route path="/" element={<Menu />} />
            <Route path="/success" element={<Success />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/poster" element={<Poster />} />
            <Route path="/brand/avatar" element={<FacebookAvatar />} />
            <Route path="/brand/cover" element={<FacebookCover />} />
            <Route path="/brand/items" element={<SocialItems />} />
            <Route path="/brand/saturday-promo" element={<SaturdayPromo />} />
            <Route path="/brand/new-ads" element={<NewItemAds />} />
            <Route path="/brand/menu-ad" element={<MenuAd />} />
            <Route path="/brand/menu-ad-v2" element={<MenuAdV2 />} />
            <Route path="/brand/menu-ad-v2-photo" element={<MenuAdV2Photo />} />
            <Route path="/brand/food-collage" element={<FoodCollage />} />
            <Route path="/brand/hook-ad" element={<HookAd />} />
            <Route path="/flyer" element={<Flyer />} />
            <Route path="/table-flyer" element={<TableFlyer />} />
            <Route path="/table-flyer/front" element={<TableFlyerFront />} />
            <Route path="/table-flyer/back" element={<TableFlyerBack />} />
            <Route path="/table-flyer/all" element={<TableFlyerAll />} />
            <Route path="/review-qr" element={<ReviewQR />} />
            <Route path="/brand/sushi-ad" element={<SushiAd />} />
            <Route path="/kitchen-chart" element={<KitchenChart />} />
            <Route path="/brand/oktoberfest" element={<OktoberfestAd />} />
            <Route path="/brand/bbq-boat-ads" element={<BBQBoatAds />} />
            <Route path="/brand/boat-hero" element={<BoatHeroAd />} />
            <Route path="/brand/cowboy-sushi" element={<CowboySushiAd />} />
          </Routes>
          <CartDrawer />
          <CartButton />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
